import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import * as L from './index.styled';
import SideNav from './SideNav';

function Layout() {
  const [$collapsed, set$collapsed] = useState(false);

  const toggle$collapsed = () => {
    set$collapsed(!$collapsed);
  };

  return (
    <L.LayoutWrapper>
      <L.Content>
        <SideNav $collapsed={$collapsed} onToggle={toggle$collapsed} />
        <Header />
        <L.MainContent $collapsed={$collapsed}>
          <Outlet />
        </L.MainContent>
      </L.Content>
    </L.LayoutWrapper>
  );
}

export default Layout;
